import React, { useState } from 'react';
import Sankey from './Sankey';
import Areachart from './AreaChart';
import MultipleSelectCheckmarks from './Dropdown';
import { Box, Paper } from '@mui/material';
// import Timeline from './TimelineChart';
import FilterMenu from './FilterMenu';
import LightScheduleChart from './lightScheduleChart';
import StaffAvailabilityChart from './staffAvailabilityChart';
import QueueChart from './QueueCount';
import DualBarChart from './dualBarChart';
import CustomerMetricsChart from './coustomerMetricChart';
import CustomerEngagementChart from './customerEngagementChart';

export default function TrendsChart() {
  const [chartvalue, setChartValue] = useState('FootFall');
  function graphToSelect(ChartData) {
    setChartValue(ChartData);
  }
  return (
    <Box
    // sx={{width: "100vw", height:"100vh", display:"flex", justifyContent:"center", alignItems:"center"}}
    >
      <div className="flex w-full justify-between">
        <MultipleSelectCheckmarks graphToSelect={graphToSelect} />
        {chartvalue === 'FootFall' && <FilterMenu />}
      </div>
      <Paper elevation={0} sx={{ width: '100%', position: 'relative', height: '408px' }}>
        {chartvalue == 'Light Timing' ? (
          <LightScheduleChart />
        ) : chartvalue == 'Staff Availability' ? (
          <StaffAvailabilityChart />
        ) : chartvalue == 'Queue Count' ? (
          <QueueChart />
        ) : chartvalue == 'Interaction' ? (
          <DualBarChart />
        ) : chartvalue == 'Departmental Conversion' ? (
          <CustomerMetricsChart />
        ) : chartvalue == 'Customer-Product Engagement' ? (
          <CustomerEngagementChart />
        ) : chartvalue == 'Journey' ? (
          <Sankey />
        ) : (
          <Areachart />
        )}
        {/* chartvalue == 'Engagement' ? <Timeline /> */}
      </Paper>
    </Box>
  );
}
